import queryString from 'query-string';
import {createContext} from 'react';

export const ScreenFormatContext = createContext(false);
export const FileSizeContext = createContext(10000000);
export const FileExtWhiteList = [];
export const GlobalDebugMode = queryString.parse(window.location.search)["d"] === "1";
export const LanguageChangeEnabled = queryString.parse(window.location.search)["l"] === "1";
export const CommandContext = createContext(null);